module.exports = __webpack_public_path__ + "static/media/Restrooms-f.d147116a.webp";